import { PropertyManagementSystem } from "shared/types/partner";
import { PMSNames } from "views/settings-integration/integrations/pms/constants";

export enum ActorFilter {
  ALL = "all",
  PARTNER = "partner",
  PMI_SYNC = "pmi_sync"
}

export const ACTOR_FILTER_LABELS: Record<ActorFilter, string> = {
  [ActorFilter.ALL]: "All",
  [ActorFilter.PARTNER]: "Manual",
  [ActorFilter.PMI_SYNC]: "PMS sync"
};

const DEFAULT_PMS_LABEL = "PMS";

export const pmsDisplayName = (pmsType: string | null): string =>
  (pmsType && PMSNames[pmsType as PropertyManagementSystem]) ||
  DEFAULT_PMS_LABEL;

export const ACTOR_FILTER_ORDER: ActorFilter[] = [
  ActorFilter.ALL,
  ActorFilter.PARTNER,
  ActorFilter.PMI_SYNC
];
